import React, { useState, useRef } from "react";
import Button from "../..//Elements/Button/Button.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import classNames from "classnames";
import PropTypes from "prop-types";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";
import useOnClickOutside from "../../../hooks/useOnClickOutside.js";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";

import "./PopupContainer.scss";
import { useContent } from "contexts/contentContext/contentContext.js";

const PopupContainer = ({
  children,
  icon,
  containerClassName,
  contentClassName,
  tooltipKey,
  ...rest
}) => {
  //button clicking behavior
  const { getTextByKey } = useContent();
  const [isClicked, setIsClicked] = useState(false);
  const ref = useRef();
  const handleClick = (isClickedOnButton) => {
    setIsClicked((prev) => !prev);
  };
  useOnClickOutside(ref, () => setIsClicked(false));

  //elements classes
  const classes = getClassName(rest);
  const ContainerClassNames = classNames([
    "popup-container",
    containerClassName,
  ]);
  const ContentClassNames = classNames([
    "popup-container-content",
    classes,
    contentClassName,
  ]);

  return (
    <div ref={ref} className={ContainerClassNames}>
      <AnimationContainer
        animationOn={isClicked}
        animationClassName="fade-in"
        containerElementClassName="fade-in"
      >
        <div className={ContentClassNames}>{children}</div>
      </AnimationContainer>

      <Tooltip
        id={"backgroundBrandingCoverIcon"}
        tooltipTextKey={tooltipKey}
        top
      >
        <button
          onClick={handleClick}
          className="branding-button"
          aria-label={getTextByKey("branding-button")}
        >
          <Icon name={icon} white></Icon>
        </button>
      </Tooltip>
    </div>
  );
};
PopupContainer.defaultProps = {
  icon: "question-mark",
  containerClassName: "",
  contentClassName: "",
};

PopupContainer.propTypes = {
  small: PropTypes.bool,
  large: PropTypes.bool,
  narrow: PropTypes.bool,
};
function getClassName(props) {
  const classes = [""];
  if (props.small) classes.push("small-popup");
  if (props.large) classes.push("large-popup");
  if (props.narrow) classes.push("narrow-popup");
  if (props.bottom) classes.push("bottom-popup");
  return classNames(classes);
}
export default PopupContainer;
